<template>
  <b-row>
    <template v-if="tempGlobalAddonDoc.visible == false">
      <b-col>
        <v-btn color="blue darken-1" text @click="addService">
          <v-icon dark>mdi-plus</v-icon>
          {{ $t("ADD") }} {{ $t("ADDON") }}
        </v-btn>
      </b-col>
    </template>
    <template v-if="tempGlobalAddonDoc.visible == true">
      <b-col :sm="12">
        <v-btn color="red darken-1" text @click="removeService">
          <v-icon dark>mdi-minus</v-icon>
          {{ $t("REMOVE") }}
          {{ $t("ADDON") }}
        </v-btn>
        <h3>{{ $t("ADDON") }}:</h3>
      </b-col>
      <b-col
        lg="3
      "
      >
        <v-autocomplete
          hide-details
          :items="contractors"
          :label="$t('CONTRACTOR')"
          item-text="name"
          item-value="id"
          clearable
          v-model="tempGlobalAddonDoc.contractorId"
        ></v-autocomplete>
      </b-col>
      <b-col>
        <v-text-field
          v-model="tempGlobalAddonDoc.num"
          :label="$t('DOC_NUM')"
          hide-details
          type="number"
          step="1"
          min="0"
        ></v-text-field>
      </b-col>
      <b-col>
        <FormDatepickerBase
          :type="'text'"
          :i18n="{
            label: 'DOC_DATE',
            placeholder: $t('DOC_DATE')
          }"
          :date.sync="tempGlobalAddonDoc.date"
        ></FormDatepickerBase>
      </b-col>
      <b-col>
        <v-text-field
          v-model="tempGlobalAddonDoc.totalCurrency"
          :label="$t('TOTAL_PRICE')"
          hide-details
          type="number"
          step="1"
          min="0"
        ></v-text-field>
      </b-col>
      <b-col lg="1">
        <v-select
          hide-details
          :items="currencies"
          item-text="code"
          item-value="id"
          :label="$t('CURRENCY')"
          v-model="tempGlobalAddonDoc.currencyId"
        ></v-select>
      </b-col>
      <b-col lg="1">
        <v-select
          hide-details
          :items="vatGroups"
          item-text="name"
          item-value="id"
          :label="$t('VAT_GROUPS')"
          v-model="tempGlobalAddonDoc.vatGroupId"
        ></v-select>
      </b-col>
    </template>
  </b-row>
</template>
<script>
import FormDatepickerBase from "@/view/content/forms/components/FormDatepickerBase.vue";
import _ from "lodash";
export default {
  name: "SetAddonDoc",
  inheritAttrs: false,
  props: {
    firstLoader: {
      type: Boolean,
      default: true
    },
    vatGroups: {
      type: Array,
      default: function() {
        return [];
      }
    },
    currencies: {
      type: Array,
      default: function() {
        return [];
      }
    },
    contractors: {
      type: Array,
      default: function() {
        return [];
      }
    },
    globalAddonDoc: {
      type: Object,
      default: function() {
        return {
          visible: false,
          num: "",
          date: "",
          vatGroupId: 3,
          currencyId: 1,
          totalCurrency: "0.00"
        };
      }
    }
  },
  data() {
    return {};
  },
  components: { FormDatepickerBase },
  mounted() {},
  computed: {
    tempFirstLoader: {
      get: function() {
        return this.firstLoader;
      },
      set: function(newValue) {
        this.$emit("update:firstLoader", newValue);
      }
    },
    tempGlobalAddonDoc: {
      get: function() {
        return this.globalAddonDoc;
      },
      set: function(newValue) {
        this.$emit("update:globalAddonDoc", newValue);
      }
    }
  },
  watch: {
    "tempGlobalAddonDoc.contractorId": function(newValue) {
      if (newValue) {
        const selectedContractor = this.contractors.find(c => c.id === newValue);
        if (selectedContractor) {
          this.tempGlobalAddonDoc.currencyId = selectedContractor.currency_id;
          this.tempGlobalAddonDoc.vatGroupId = selectedContractor.vat_group_id;
        }
      }
    }
  },
  methods: {
    addService() {
      let vm = this;
      vm.tempGlobalAddonDoc.visible = true;
    },
    removeService() {
      let vm = this;
      vm.tempGlobalAddonDoc.visible = false;
    }
  }
};
</script>
